const locale = {
  test: 'test',
  empty: 'Aucune donnée',
  basicLanguagaeLabel: 'Français',
  date: {
    formats: {
      tiny: 'DD/MM/YY',
      short: 'DD/MM/YYYY',
    },
  },
  common: {
    all: 'Toutes',
    selectAll: 'Tout sélectionner',
    of: 'du',
    yes: 'oui',
    no: 'non',
    and: 'exactement (tous)',
    or: 'contient au moins',
  },
  list_circulation: {
    CHART_TRANSPORTATION_PLAN: 'Plan de transport',
    CHART_DATE: 'Date',
    CHART_TRAIN: 'Train',
    CHART_DEPARTURE: 'Départ',
    CHART_STATION: 'Gare',
    CHART_TIME: 'Heure',
    CHART_ARRIVAL: 'Arrivée',
    CHART_PASSENGER_NUMBER: 'Nombre de passagers',
    CHART_WAGON_1: 'Rame 1',
    CHART_WAGON_2: 'Rame 2',
    CHART_PASSENGERS_1: '1-8(10)',
    CHART_PASSENGERS_2: '11-18',
    CHART_LAST_SEND_TYPE: 'Nature du dernier envoi',
    CHART_LAST_SEND_SCHEDULE: 'Date et heure du dernier envoi',
    CHART_LAST_SEND_DETAILS: 'Dét',
    CHART_PRE_OP_COM: 'En pré-opérationnel',
    CHART_OP_COM: 'En opérationnel',
    CHART_POST_OP_COM: 'Communiquer en post-opérationnel',
    CHART_COM_CANCELLATION: 'Annulation',
    CHART_PRE_OP_COM_OTHER: 'Autres informations pré-opérationnelles',
    CHART_OP_COM_OTHER: 'Autres informations Opérationnelles',
    CHART_COM_DIVERSION: 'Détournement',
    CHART_COM_STATION_LIMITATION: 'Limitation de desserte	',
    CHART_PLATFORM: 'Annonce du quai',
    CHART_COM_DELAY: 'Retard',
    CHART_COM_NORMAL: 'Trafic normal',
    CHART_COM_NB_PASSENGERS: 'Nombre de sièges occupés',
    CHART_COM_LAST_COM: 'Précédentes communications',
    CHART_COM_LAUNCH_COM: 'Emettre une communication',
  },
  form: {
    FORM_USER_NAME: 'Nom',
    FORM_USER_SURNAME: 'Prénom',
    FORM_USER_PROFIL: 'Profil',
    FORM_USER_GROUP: 'Groupe',
    FORM_USER_CIRCULATION_TYPE: 'Type de circulation',
    FORM_USER_CIRCULATION_TYPE_CLASSIC: 'Train classique',
    FORM_USER_CIRCULATION_TYPE_SPEED: 'Grande Vitesse',
    FORM_PROFILE_TYPE_ADMIN: 'Administrateur',
    FORM_PROFILE_TYPE_TI_SUPERVISOR: 'Superviseur IV',
    FORM_CREATION_DATE: 'Date de création :',
    FORM_RESET_PASSWORD: 'Réinitialiser le mot de passe',
    FORM_EXPIRED_PASSWORD: 'Renouveler le mot de passe',
    FORGOT_PASSWORD_LINK: 'Mot de passe oublié ?',
    FORM_CONNECT_LINK: 'Se connecter',
    RESET_PASSWORD_REQUEST: 'Demande de réinitialisation de mot de passe',
    FORM_USERNAME: 'Identifiant',
    FORM_EMAIL: 'Adresse e-mail',
    FORM_PASSWORD: 'Mot de passe',
    FORM_CONFIRM_PASSWORD: 'Confirmez votre mot de passe',
    TEMPORARY_PASSWORD_EMAIL_SENT: 'Un e-mail de confirmation va être envoyé à cette adresse.',
    RESET_PASSWORD_OK: 'La réinitialisation de mot de passe a été prise en compte.',
    FORM_CONNECT_ERROR: 'Identifiant et/ou mot de passe invalide',
    FORM_FORGOT_PASSWORD_ERROR: 'Une erreur est apparue avec votre email.',
    FORM_CONNECT_TITLE: 'Connexion',
    FORM_FORGOT_PASSWORD_TITLE: 'Mot de passe oublié',
    FORM_USER_ALLREADY_EXIST: 'Cette adresse e-mail existe déjà.',
    FORM_USER_EMAIL_ALLREADY_EXIST: 'Cette adresse e-mail existe déjà.',
    FORM_USER_USERNAME_ALLREADY_EXIST: 'Cet identifiant existe déjà.',
    FORM_TYPOLOGY_ALLREADY_EXIST: 'Cette typologie existe déjà.',
    FORM_PROFIL_ALLREADY_EXIST: 'Ce profil existe déjà.',
    FORM_SITUATION_ALLREADY_EXIST: 'Cette situation existe déjà pour ce processus.',
    FORM_REASON_ALLREADY_EXIST: 'Ce motif existe déjà.',
    FORM_PRODUCT_CODE_ALLREADY_EXIST: 'Ce code produit existe déjà.',
    FORM_UNKNOWN_ERROR: "Une erreur est apparue. L'opération a échoué.",
    FORM_UPDATE_TEMP_PASSWORD: 'Mot de passe reçu',
    FORM_EXPIRED_CURRENT_PASSWORD: 'Mot de passe actuel',
    FORM_UPDATE_NEW_PASSWORD: 'Nouveau mot de passe',
    FORM_UPDATE_CONFIRM_PASSWORD: 'Confirmez votre nouveau mot de passe',
    FORM_WRONG_TEMPORARY_PWD: 'Mot de passe temporaire incorrect',
    IMPACTED_CUSTOMERS_SELECTION_H3: 'Sélectionner le type de clients',
    IMPACTED_DV_NUMBERS_H3: 'Saisir des n° de DV',
    DEPARTURE_STATIONS_IMPACTED_H3: 'Sélectionner la(les) gare(s) concernée(s)',
    ALL_CUSTOMERS: 'Tous les clients du train	',
    DESCENDING_CUSTOMERS: ' Clients descendants en gare',
    ASCENDING_CUSTOMERS: ' Clients montants en gare',
    ASCENDING_DESCENDING_CUSTOMERS: 'Clients montants et descendants en gare',
    ASCENDING_STATIONS_EXCLUSION_H3: 'Exclusion de gare(s) de montée (facultatif)',
    CUSTOMER_SELECTION_IN_COACHES_H3: 'Sélectionner les clients présents dans les voitures',
    CHART_WAGON_1: '1 à 8	',
    CHART_WAGON_2: '9 à 16',
    ADDITIONNAL_CUSTOMER_INFO_H3: 'Renseigner l’information complémentaire clients',
    CHART_REASON: 'Motif',
    CHART_SITUATION: 'Situation',
    NEW_TITLE: 'Eléments de contextualisation',
    NEW_TITLE1: 'Objet du mail',
    NEW_TITLE11: 'Objet du mail : ',
    NEW_TITLE2: 'Titre du bandeau',
    NEW_TITLE22: 'Titre du bandeau : ',
    NEW_TITLE3: '¡Échale un ojo! Información sobre tu viaje del jj/mm/aaaa.',
    NEW_TITLE4: 'Algo ha cambiado. Y queremos que lo sepas.',
    NEW_TITLE5: '¡Échale un ojo! Información importante sobre tu viaje',
    NEW_TITLE6: 'Atento. Sabemos que esto te interesa',
    NEW_TITLE7: '¡Échale un ojo! Información importante sobre tu viaje del jj/mm/aaaa. ',
    NEW_TITLE8: 'Choisir la situation',
    NEW_TITLE20: "Aucun modèle d'e-mail associé.",
    NEW_TITLE21: 'Aucun modèle de WhatsApp associé.',
    NEW_TITLE9: 'Autres',
    NEW_TITLE10: 'Bar fermé',
    NEW_TITLE33: 'Réduction de composition UM > US',
    NEW_DEPARTURE_STATION_AND_SCHEDULE_H3: 'Renseignez la nouvelle gare ainsi que le nouvel horaire associé',
    NEW_SCHEDULE: 'Nouvel horaire :	',
    P_H_SUBSTITUTION_STATION: 'Gare de substitution',
    P_H_TIME_FORMAT: 'HH:mm',
    INCIDENT_DETAILS_H4: 'Détails sur l’incident',
    COMPENSATION_MEASURES_AND_AFTERSALES_H4: 'Mesures de prise en charge et de SAV',
    SIGNATURE_H4: 'Signature',
    CUSTOMERS_INDEMNIFICATION_H3: 'Compensation clients',
    ASCENDING_CUSTOMERS_LIMITATION: 'Clients prévus à la montée sur la desserte limitée',
    DESCENDING_CUSTOMERS_LIMITATION: 'Clients prévus à la descente sur la desserte limitée',
    SELECT_IMPACTED_SEGMENTS_LIMITATION_H3: 'Sélectionner le (ou les) segment(s) concerné(s)',
    DELAY_TYPE_H3: 'Sélectionnez le type de retard',
    ARRIVAL_DELAY_DESCENDING_CUSTOMERS: 'Retard au départ (clients montants en gare)',
    DEPARTURE_DELAY_ASCENDING_CUSTOMERS: "Retard à l'arrivée (clients descendants en gare)",
    IMPACTED_STATIONS_DIVERSION_H3: 'Sélectionner la (ou les) gare(s) concernée(s) par le détournement',
    SELECT_IMPACTED_STATION_DELAY: 'Sélectionner la (ou les) gare(s) concernée(s)',
    SELECT_IMPACTED_STATION_H3: 'Sélectionner la (ou les) gare(s) concernée(s)',
    INFORMATION_COM_H4: 'Information à communiquer',
    DEPARTURE_PLATFORM_H3: 'Renseignez le quai',
    'P-H-PLATFORM': 'Quai :',
    OTHER_INFORMATION_COM_H4: 'Autres informations',
    NEW_SCHEDULE_H3: 'Renseignez le retard',
    NEW_SCHEDULE_H4: 'Autre :',
    SELECTED_SEGMENT_H3: 'Informations concernant le segment ',
    SELECTED_STATION_H3: '	Informations concernant la gare ',
    ALL_STATIONS_CONCERNED: 'Information concernant toutes les gares',
    WARNING_COMPENSATION_CREATED:
      'Attention, cette action nécessite la validation du superviseur. Vous êtes sur le point de créer une compensation de ',
    CHART_PROCESS: 'Processus',
    MESSAGE_LONG: 'Message long',
    MESSAGE_COURT: 'Message court',
    SITUATION: 'Processus - Situation',
    SUB_FAMILY: 'Sous-famille',
    CHART_TYPOLOGY: 'Choisir un(des) code(s) produit',
    CHART_PRODUCT_CODE: 'Code produit',
    CHART_BUSINESS_CASE: 'Cas métier',
    CHOOSE_BUSINESS_CASE: 'Choisir un cas métier',
    EDIT_REASON: 'Edition du motif',
    CREATE_REASON: 'Motif à créer',
    FILTER_BUSINESS_CASE: 'Cas métier',
    FILTER_DEPARTURE_DATE: 'Date de circulation du',
    FILTER_END_DATE: 'Au',
    FILTER_SENDING_DATE_FROM: "Date d'envoi du",
    FILTER_SENDING_DATE_TO: 'Au',
    FILTER_CREATION_DATE_FROM: 'Date de création du',
    FILTER_CREATION_DATE_TO: 'Au',
    FILTER_TRANSMITTER: 'Emetteur',
    FILTER_STATUS: 'Statut',
    FILTER_STATION_IMPACTED: 'Gare',
    RESET_COMPENSATION: 'Annuler compensation',
    FORM_STATIONS: 'Gare',
    EMAIL_INFO: 'NB : Une modification de votre propre compte entraînera votre déconnexion automatique.',
    FORM_SITUATION: 'Nom de situation',
    FORM_TYPOLOGY: 'Nom de la typologie',
    REASON: "Bloc 'Motif'",
    DELAY: "Bloc 'Volume de retard'",
    SUBSTITUTE: "Bloc 'Gare de substitution & Nouvel horaire'",
    DOCK: "Bloc 'Quai'",
    COMM_INFO: "Bloc 'Information à communiquer'",
    COMM_INFO_LONG: 'Message long',
    COMM_INFO_SHORT: 'Message court',
    MORE_INFO: "Bloc 'Information complémentaire'",
    COMPENSATION: "Bloc 'Mesures & Dédommagement'",
    COMPENSATION_ALL: 'Tous clients',
    COMPENSATION_DOWN: 'Clients descendants',
    COMPENSATION_UP: 'Clients montants',
    COMPENSATION_UP_DOWN: 'Clients montants et descendants',
    COMPENSATION_DV_NUMBERS: 'N° de DV',
    SIGN: "Bloc 'Signature'",
    YES: 'oui',
    NO: 'non',
    ADD_MODIFICATION: 'ajout/modification',
    CONSULTATION: 'consultation',
    UNIQUE: 'uniquement son compte',
    ALL: `tous (pas d'ajout)`,
    READ_ONLY: `tous (consultation seule)`,
    NAME: 'Libellé',
    Circulations: 'Circulations > Vue',
    Historisation: 'Historisation > Vue',
    'Customer-Flux': 'Flux clients > Vue',
    Reasons: 'Référentiels > Motifs',
    'Help-Info': "Référentiels > Aides à l'information",
    Typologies: 'Référentiels > Typologies',
    Situations: 'Référentiels > Situations',
    Profiles: 'Accès > Profils',
    Users: 'Accès > Utilisateurs',
    Communication: 'Fonctionnalité : Envoi de communication',
    'Deffered-Communications': 'Fonctionnalité : Envoi en différé',
    PLATFORM: 'Quai',
    SHORT_MESSAGE: "contenu 'brut' SMS",
    circulationType: 'Type de circulation',
    situationsProcess: 'Situations',
  },
  customer: {
    ALL_CUSTOMERS: 'Tous les clients',
    DESCENDING_CUSTOMERS: 'Clients descendants',
    ASCENDING_CUSTOMERS: 'Clients montants',
  },
  formErrors: {
    REQUIRED_FIELD: 'Champ obligatoire',
    STRING_MAX: 'Ce champ ne peut excéder 100 caractères',
    NOT_VALID_EMAIL: 'Cet email est invalide.',
    PASSWORD_RULES:
      'Votre mot de passe doit contenir au moins 12 caractères dont 1 minuscule, 1 majuscule, 1 chiffre et 1 caractère spécial.',
    STRING_MAX_10_CHARACTERS: 'Ce champ ne peut excéder 10 caractères',
    STRING_MAX_20_CHARACTERS: 'Ce champ ne peut excéder 20 caractères',
    PASSWORD_CONFIRM: 'Les deux mots de passe ne correspondent pas',
    ROLE_EMPTY: 'Au moins un profil est requis',
    INCOMPLETE_ERROR: 'Veuillez renseigner ce champ obligatoire',
    INCOMPLETE_DIFFERED_ERROR: "Veuillez renseigner ou changer de moment d'envoi.",
    INVALID_FORMAT: 'Veuillez vérifier le format',
    NAME_RULES: 'Nom ou prénom invalide',
    USERNAME_RULES: 'Identifiant invalide',
    FORBIDDEN_CHARACTERS_ERROR_MESSAGE: 'Présence de caractères interdits.',
    ELEMENT_LENGTH_ERROR_MESSAGE: 'Format de DV incorrect.',
  },
  menu: {
    MENU_ITEM_1: 'Circulations',
    MENU_ITEM_2: 'Flux clients',
    MENU_ITEM_3: 'Administration',
    MENU_ITEM_4: 'Historisation des messages',
    MENU_ITEM_4_1: 'Par OD',
    MENU_ITEM_4_2: 'Par gare',
    MENU_ITEM_3_1: 'Référentiels',
    MENU_ITEM_3_2: 'Utilisateurs',
    MENU_ITEM_3_1_1: "Aides à l'information",
    MENU_ITEM_3_1_1_1_1: 'Référentiel des phrases-types',
    MENU_ITEM_3_1_1_1: 'PHRASES-TYPES',
    MENU_ITEM_3_1_1_2: 'PHRASES DÉDOMMAGEMENT',
    MENU_ITEM_3_1_2: 'Motifs',
    MENU_ITEM_3_1_3: 'Situations',
    MENU_ITEM_3_1_4: 'Typologies passager',
    MENU_ITEM_3_1_3_1: 'Situations',
    MENU_ITEM_3_1_3_2: 'Masques Messages',
    MENU_ITEM_3_1_3_3: 'CONSTITUTION COMMUNICATION',
    MENU_ITEM_3_1_4_1: 'Codes Produits',
    MENU_ITEM_3_1_4_2: 'Typologies',
    MENU_ITEM_3_3: 'ACCÈS',
    MENU_ITEM_3_3_3: 'PROFILS',
  },
  header: {
    TITLE1: 'Oui',
    TITLE2: 'News',
    passwordExpiryMessage: 'Expiration prochaine de votre mot de passe',
    passwordExpiryTooltip: 'Rendez-vous en page de connexion > "Mot de passe oublié ?" ',
  },
  Buttons: {
    NEW_USER_CREATION_BUTTON: 'Nouvel utilisateur',
    NEW_PROFIL_CREATION_BUTTON: 'Nouveau profil',
    SEARCH_BUTTON: 'Rechercher',
    SAVE_BUTTON: 'Enregistrer',
    CREATE_BUTTON: 'Créer',
    CANCEL_BUTTON: 'Annuler',
    RESET_BUTTON: 'Réinitialiser',
    CONNECT_BUTTON: 'Se connecter',
    DISCONNECT_BUTTON: 'Se déconnecter',
    NEXT_BUTTON: 'Suivant',
    CONTINUE_BUTTON: 'Continuer',
    EDIT_BUTTON: 'Modifier',
    COPY_INFO_BUTTON: 'Recopier les informations sur toutes les gares suivantes',
    COPY_INFO_BUTTON_LIMITATION: 'Recopier les informations sur tous les segments suivants',
    COPY_DELAY_BUTTON: 'Recopier le volume de retard sur toutes les gares suivantes',
    SEND_BUTTON: 'Envoyer',
    TEMPLATE_BUTTON: 'Aperçu du message',
    PREVIOUS_BUTTON: "Retour à l'étape précédente",
    ADD_HELP_BUTTON: 'Ajouter une phrase type',
    ADD_REASON: 'Ajouter un motif',
    ADD_SITUATION: 'Ajouter une nouvelle situation',
    ADD_PRODUCT_CODE: 'Ajouter un code produit',
    ADD_TYPOLOGY: 'Ajouter une nouvelle typologie',
  },
  filtre: {
    SEARCH_FILTER_TITLE: 'Filtres de recherche',
    SEARCH_FILTER_TRAIN_NUMBER: 'N° du train',
    SEARCH_FILTER_DEPARTURE_STATION: 'Gare de départ',
    SEARCH_FILTER_ARRIVAL_STATION: "Gare d'arrivée",
    SEARCH_FILTER_DEPARTURE_DATE: 'Date de début',
    SEARCH_FILTER_END_DATE: 'Date de fin',
    SEARCH_FILTER_WEEKDAYS: 'Jour(s)',
    SEARCH_FILTER_FILTER_BUTTON: 'Filtrer',
    SEARCH_FILTER_RESET_BUTTON: 'Réinitialiser',
    SEARCH_FILTER_REFRESH_BUTTON: 'Rafraîchir',
    SEARCH_FILTER_REFRESH_BUTTON_TOOLTIP: 'à concurrence de "Date de début" +10 jours',
    SEARCH_FILTER_ONLY_PENDING: 'Si coché : uniquement les envois programmés',
    SEARCH_FILTER_NEEDS_DATES: 'Veuillez saisir au moins une période de dates.',
    HISTORISATION_TABLE: 'Historisation des messages',
    HISTORISATION_PENDING_TABLE: 'Messages programmés en attente',
    HISTORISATION_PENDING_LINK: 'Messages programmés en attente >>',
    REFRESH_LABEL: 'Résultats générés',
    REFRESH_LABEL_DAY: 'le',
    REFRESH_LABEL_TIME: 'à',
    SITUATION: 'Processus - Situation',
    CONTENT: 'Contenu',
    SUB_FAMILY: 'Sous-famille',
    INCLUDED_CANCEL: 'Annulations incluses',
    INCLUDED_ROLLING: '+LR',
    INCLUDED_ROLLING_TOOLTIP: 'Si coché : inclura les trains du même roulement',
    TYPE_CIRCULATION: 'Type(s) de circulation',
    HISTO_TYPE_CIRCULATION: 'Type de circulation',
  },
  CirculationPage: {
    CIRCULATION_TABLE: 'Tableau des circulations',
    BULK_COMMUNICATIONS: 'Envoi en masse',
    PRE_OP: 'PRÉ-OP',
    OP: 'OPÉ',
    BULK_COMMUNICATIONS_ERROR: 'Impossible : toutes les circulations doivent être du même type de circulation',
  },
  UserPage: {
    USER__PAGE_H2: 'Gestion des utilisateurs',
    USER_RESEARCH_PAGE_H2: 'Rechercher un utilisateur',
    USER_BACK: 'Retour à la liste des utilisateurs',
    USER_CREATE: 'Créer un utilisateur',
    USER_UPDATE: 'Modifier un utilisateur',
  },
  ProductCodesPage: {
    PRODUCT_CODES_REPOSITORY_PAGE_H2: 'Référentiel des codes produit',
    PRODUCT_CODES_BACK: 'Retour à la liste des codes produit',
    PRODUCT_CODES_CREATE: 'Ajouter un code produit',
  },
  ProfilPage: {
    PROFIL_RESEARCH_PAGE_H2: "Gestion des profils d'accès",
    PROFIL_BACK: 'Retour à la liste des profils',
    PROFIL_CREATE: 'Créer un profil',
    PROFIL_UPDATE: 'Modifier un profil',
  },
  ReasonPage: {
    REASON_REPOSITORY_PAGE_H2: 'Référentiel des motifs',
    REASON_BACK: 'Retour à la liste des motifs',
    REASON_CREATE: 'Créer un motif',
    REASON_UPDATE: 'Modifier un motif',
  },
  ConstitutionPage: {
    CONSTITUTION_REPOSITORY_PAGE_H21: 'Paramétrage de la constitution de la communication par situation',
    CONSTITUTION_UPDATE: 'Modifier la constitution de la communication',
    CONSTITUTION_BACK: 'Retour au paramétrage de la constitution de la communication par situation',
  },
  SituationPage: {
    SITUATION_REPOSITORY_PAGE_H21: 'Référentiel des situations',
    SITUATION_CREATE1: 'Ajouter une nouvelle situation',
    SITUATION_REPOSITORY_PAGE_H2: 'Créer une situation',
    SITUATION_BACK: 'Retour à la liste des situations',
    SITUATION_CREATE: 'Créer une situation',
    SITUATION_UPDATE: 'Modifier une situation',
  },
  MaskPage: {
    MASK_REPOSITORY_PAGE_H2: 'Paramétrage des masques de messages par situation',
    MASK_BACK: 'Retour au paramétrage des masques de message par situation',
    MASK_UPDATE: 'Modifier les masques de message',
  },
  TypologyPage: {
    TYPOLOGY_REPOSITORY_PAGE_H21: 'Referencial de typologies',
    TYPOLOGY_CREATE1: 'Ajouter une nouvelle typologie',
    TYPOLOGY_REPOSITORY_PAGE_H2: 'Référentiel des typologies de passager',
    TYPOLOGY_BACK: 'Retour à la liste des typologies',
    TYPOLOGY_CREATE: 'Créer une typologie',
    TYPOLOGY_UPDATE: 'Modifier une typologie',
  },
  HelpInfoPage: {
    HELP_INFOS_BACK: 'Retour à la liste des phrases-types',
    HELP_INFO_CREATE: 'Créer une phrase-type',
    HELP_INFO_UPDATE: 'Modifier une phrase-type',
    LONG_MSG: 'Message long',
    SHORT_MSG: 'Message court (facultatif)',
    SITUATION_CHOICE: 'Choisir une (des) situation(s)',
    SUB_FAMILY: 'Sous-famille (facultatif)',
    ALLREADY_EXIST: 'Cette phrase-type existe déjà.',
    CIRCULATION_TYPES_CHOICE: 'Choisir un (des) type(s) de circulation',
  },
  CompensationSentencePage: {
    TITLE: 'Référentiel des phrases automatiques en fonction du dédommagement',
    BACK: 'Retour à la liste des phrases automatiques dédommagement',
    TITLE_UPDATE: 'Modifier une phrase automatique dédommagement',
    NAME: 'Compensation',
    LONG_MSG: 'Message long',
  },
  customersStationPage: {
    title: 'Tableau des flux clients : par gare',
    linkOD: '>> par OD',
    linkStation: '>> par gare',
  },
  customersODPage: {
    title: 'Tableau des flux clients : par OD',
  },
  Error404: {
    ERROR404_TITLE: 'erreur 404 - page introuvable',
    ERROR404_MESSAGE: "Une erreur s'est produite: 404 - Page introuvable",
    ERROR404_BACK: "Revenir à la page d'accueil",
  },
  processus: {
    OP: 'Communiquer en opérationnel',
    PRE_OP: 'Communiquer en pré-opérationnel',
    POST_OP: 'Communiquer en post-opérationnel',
  },
  process: {
    operational: 'Opérationnel',
    'pre-operational': 'Pré-opérationnel',
    'post-operational': 'Post-opérationnel',
  },
  env: {
    front: 'IHM',
    middleware: 'middleware',
  },
  businessCases: {
    'OP-CANCELLATION': 'Annulation',
    'OP-DELAY': 'Retard',
    'OP-DIVERSION': 'Détournement',
    'OP-OTHER': 'Autres informations opérationnelles',
    'OP-PLATEFORM': 'Annonce du quai',
    'OP-STATION_LIMITATION': 'Limitation de desserte',
    'POST-OP-DELAY': 'Retard',
    'POST-OP-NORMAL': 'Trafic normal',
    'PRE-OP-CANCELLATION': 'Annulation',
    'PRE-OP-DELAY': 'Retard',
    'PRE-OP-DIVERSION': 'Détournement',
    'PRE-OP-OTHER': 'Autres informations pré-opérationnelles',
    'PRE-OP-STATION_LIMITATION': 'Limitation de desserte',
  },
  businessCasesCirculation: {
    'POST-OP-NORMAL': 'Post opérationnel - Trafic normal',
    'OP-PLATEFORM': 'Opérationnel - Annonce du quai',
    'PRE-OP-CANCELLATION': 'Pré-opérationnel - Annulation',
    'OP-CANCELLATION': 'Opérationnel - Annulation',
    'OP-OTHER': 'Opérationnel - Autres informations',
    'PRE-OP-OTHER': 'Pré-opérationnel - Autres informations',
    'PRE-OP-DIVERSION': 'Pré-opérationnel - Détournement',
    'OP-DIVERSION': 'Opérationnel - Détournement',
    'OP-STATION_LIMITATION': 'Opérationnel - Limitation de desserte',
    'PRE-OP-STATION_LIMITATION': 'Pré-opérationnel - Limitation de desserte',
    'OP-DELAY': 'Opérationnel - Retard',
    'PRE-OP-DELAY': 'Pré-opérationnel - Retard',
    'POST-OP-DELAY': 'Post-opérationnel - Retard',
    'PRE-OP-DELAY-ARRIVAL': "à l'arrivée",
    'PRE-OP-DELAY-DEPARTURE': 'au départ ',
  },
  sendCommunication: {
    serviceSummary: 'Train %{name} du %{date}',
    'step-1': 'ciblage',
    'step-2': 'message',
    CHART_DATE: 'Date',
    CHART_TRAIN: 'Train',
    trains: 'Trains',
    trainsPerDate: 'trains/dates',
    INFORMATION_HELP_H3: 'Phrases-types',
    modalNoPassengers: {
      desc: "Aucun passager n'est concerné. Voulez-vous tout de même continuer ?",
    },
    reminderSelections: {
      clientsType: 'Type de clients',
      clientsTypeValue: {
        all: 'tous',
        ascend: 'montants',
        descend: 'descendants',
        ascendDescend: 'montants et descendants',
      },
      DVNumbersValue: 'N° de DV',
      impactedStations: 'Gare(s) concernée(s)',
      excludedStations: 'Exclusion gare(s) de montée',
      selectedCarriages: 'Voiture(s)',
      selectedCarriagesTypeValue: {
        all: 'toutes',
        high: '%{num}-haut',
        down: '%{num}-bas',
      },
      Others: 'Autres',
      conflictedTickets: 'uniquement billets en conflit ',
      excludeAllConflictedTickets: 'billets en conflit exclus ',
      selectPurchaseDateTime:
        'acheté %{selectedPurchaseComparison} le %{selectedPurchaseDate} à %{selectedPurchaseTime}',
    },
    targetStations: {
      noStationsInCommon: 'Certains types de clients sont non compatibles avec les trains sélectionnés.',
      odsSummaryLabel: 'Récapitulatif des OD',
    },
    passengerCount: {
      headText: 'Nombre de passagers ciblés:',
      notAvailable: "Fonctionnalité disponible jusqu'à 4 trains/dates",
    },
    otherSelection: {
      headText: 'Autres sélections ?',
      typologyText: 'Typologie(s) de passagers : ',
      conflictedTickets: {
        label: 'Par rapport aux billets en conflit : ',
        onlyLabel: 'Uniquement en conflit en raison de : ',
        excludeLabel: 'Exclure les billets en conflit',
      },
      selectPurchase: {
        label: "Moment de l'achat :",
        date: 'Date:',
        hour: 'Heure:',
        before: 'strictement avant',
        after: 'strictement après',
        error: 'Veuillez renseigner tous les champs ou aucun.',
      },
    },
    carriagesSelection: {
      includePassengers: 'inclure les passagers "sans placement"',
      includePassengersTooltip: 'Exemples : régularisation à bord, billet acheté à quai, titre émis à 0, ...',
    },
    situationSelection: {
      situationLabel: 'Situation',
      motifLabel: 'Motif',
      labelOther: 'Autre :',
    },
    communicationChannels: {
      title: "Choisir les canaux d'envoi",
      mail: 'Mail',
      sms: 'SMS',
      whatsApp: 'WhatsApp',
      flashInfo: 'Flash-info',
    },
    substitutionSchedule: {
      substitutionLabel: 'Gare de substitution',
      scheduleLabl: 'Nouvel horaire',
      placeholder: '{en toutes lettres}',
      numberOfChars: '(%{numberOfChars} caractère(s))',
    },
    compensation: {
      savLabel: 'Mesures de prise en charge et de SAV',
      compensationLabel: 'Dédommagement clients',
      cancelCompensation: 'Annuler le dédommagement',
      confirmCompensationLabel: 'Confirmation de compensation',
      confirmModal: {
        title: "Attention, aucune compensation ne sera créée. Voulez-vous poursuivre l'envoi ou le modifier ?",
        btnCancel: 'Ne pas envoyer et modifier.',
        btnConfirm: "Confirmer l'envoi.",
      },
    },
    placeHolder: {
      modal: {
        title: 'Attention : contenu à vérifier dans un champ de message.',
        btnCancel: 'Modifier',
        btnConfirm: 'Poursuivre',
      },
    },
    prohibitedLinks: {
      modal: {
        title: 'Attention : contenu à vérifier dans un lien hypertexte inséré.',
        btnCancel: 'Modifier',
        btnConfirm: 'Poursuivre',
      },
    },
    backToPreviousStep: "Retour à l'étape précédente",
    signatureTitle: 'Signature',
    msgsPreview: {
      titleAllStations: 'Concernant toutes les gares',
      titleImpactedStations: 'Concernant la gare %{name}',
      textNoTemplates: 'Pas de message à prévisualiser.',
    },
    differedCommunication: {
      title: "Moment de l'envoi",
      immediatLabel: 'immédiat',
      differedLabel: 'en différé :',
      differedNumberDaysLabel: 'nb jours avant circulation',
      differedNumberDaysTooltip:
        'NB : Seules les valeurs compatibles avec la(les) date(s) de circulation concernée(s) sont possibles.',
      differedHourLabel: "heure d'envoi",
      differedHourTooltip: 'NB : Seuls les horaires compatibles avec le nombre de jours saisi sont possibles.',
      incompatibleTime: 'Envoi en différé incompatible avec la(les) date(s) de circulation concernée(s).',
      missingAuth: 'Vous ne disposez pas des droits nécessaires.',
      dvNumbersTarget: `L'envoi en différé n'est pas autorisé avec un ciblage "N° de DV".`,
    },
  },
  table: {
    COLUMN_COMPENSATION_SENTENCES_NAME: 'Compensation',
    COLUMN_COMPENSATION_SENTENCES_LONG_MSG: 'Message long',
    COLUMN_USER_LAST_NAME: 'Nom',
    COLUMN_USER_FIRST_NAME: 'Prénom',
    COLUMN_USER_EMAIL: 'Mail de contact',
    COLUMN_USER_PROFILE: 'Profil',
    COLUMN_CIRCULATION: 'Circulations',
    COLUMN_VUE: 'Vue',
    COLUMN_HISTOTISATION: 'Historisation',
    COLUMN_FLUX_CLIENT: 'Flux clients',
    COLUMN_FONCTIONNALITES: 'Fonctionnalités',
    COLUMN_ENVOI_COMM: 'Envoi de communication',
    COLUMN_ENVOI_DIFF: 'Envoi en différé',
    COLUMN_REF: 'Administration > Référentiels',
    COLUMN_MOTIFS: 'Motifs',
    COLUMN_AIDES_INFO: "Aides à l'information",
    COLUMN_TYPO: 'Typologies',
    COLUMN_SITUATION: 'Situations',
    COLUMN_ADMIN: 'Administration > Accès',
    COLUMN_PROFIL: 'Profils',
    COLUMN_USERS: 'Utilisateurs',
    COLUMN_USER_CIRCULATION: 'Type de circulation',
    COLUMN_USER_GROUP: 'Groupe',
    COLUMN_EDIT: 'Modifier',
    COLUMN_EDIT_DELETE: 'Modifier / Supprimer',
    COLUMN_SUBSTITUTION: 'Gare de substitution & Nouvel horaire',
    COLUMN_DELAY: 'Volume retard',
    COLUMN_INFO: 'Information à communiquer',
    COLUMN_INFO_COMP: 'Information complémentaire',
    COLUMN_COMP: 'Mesures & Dédommagement',
    COLUMN_QUAI: 'Quai',
    COLUMN_LONG: 'Long',
    COLUMN_ALL: 'Tous',
    COLUMN_UP: 'Montants',
    COLUMN_DOWN: 'Descendants',
    COLUMN_UP_DOWN: 'Montants et descendants',
    COLUMN_DV_NUMBERS: 'N° de DV',
    COLUMN_COURT: 'Court',
    COLUMN_DELETE: 'Supprimer',
    CHART_PROCESS: 'Processus',
    CHART_PROCESS_SITUATION: 'Processus - Situation',
    CHART_PASSENGERS: 'Clients',
    CHART_MAIL_CHANNEL: 'Canal mail',
    CHART_CHANNEL_CHECKED: 'Canal coché par défaut',
    CHART_DEFAULT_OBJECT: 'Objet par défaut',
    CHART_DEFAULT_HEADBAND: 'Bandeau par défaut',
    CHART_DEFAULT_CHECKED: 'Coché par défaut ?',
    CHART_MASK: 'Masque',
    CHART_SMS_CHANNEL: 'Canal SMS',
    CHART_WHATSAPP_CHANNEL: 'Canal WhatsApp',
    CHART_MASK_REFERENCES: 'Référence et variables du masque',
    CHART_MASK_PREVIEW: 'Masque de prévisualisation',
    CHART_FLASH_INFO: 'FlashInfo',
    CHART_TYPOLOGY: 'Typologie',
    CHART_LINKED_PRODUCT_CODE: 'Code produit associé',
    CHART_BUSINESS_CASE: 'Cas-métier',
    CHART_PRODUCT_CODE: 'Code produit',
    CHART_REASON: 'Motif',
    CHART_SITUATION: 'Situation',
    CHART_DATE: 'Date',
    CHART_TRAIN: 'Train',
    CHART_TRAIN_STOP_DURATION: 'Durée du crochet',
    CHART_ARRIVAL_SCHEDULE: "Heure d'arrivée",
    CHART_DEPARTURE_SCHEDULE: 'Heure de départ',
    CHART_PASSENGER_NUMBER: 'Nombre de passagers',
    CHART_PASSENGER_NUMBER_UP: 'Nombre de passagers montants',
    CHART_PASSENGER_NUMBER_DOWN: 'Nombre de passagers descendants',
    CHART_DESCENDING_PASSENGERS: 'Descendants',
    CHART_DESCENDING_PASSENGERS_1: '1-8(10)',
    CHART_DESCENDING_PASSENGERS_2: '11-18',
    CHART_ASCENDING_PASSENGERS: 'Montants',
    CHART_ASCENDING_PASSENGERS_1: '1-8(10)',
    CHART_ASCENDING_PASSENGERS_2: '11-18',
    CHART_TOTAL: 'Total',
    CHART_CHILDREN: 'Dont enfants',
    CHART_PWD: 'Dont UFR',
    HART_PWD0: '(incluant UFR)',
    HART_PWD1: 'Prestations d’assistance',
    HART_PWD2: 'Montants en gare',
    HART_PWD3: 'Descendants en gare',
    CHART_BAMB: 'Bambins',
    CHART_STATION: 'Gares desservies',
    CHART_SUM: 'Total',
    CHART_SUM_1: '1-8(10)',
    CHART_SUM_2: '11-18',
    CHART_SUM_3: 'Cumul',
    CHART_SUM_3_TOOLTIP: 'Incluant les ‘sans place’',
    CHART_TYPOLOGY_PASSENGERS: 'Typologie passagers',
    CHART_DATE_TIME_SENDING: "Date et heure d'envoi",
    CHART_CREATION_DATE: 'Date et heure de la création',
    CHART_TRANSMITTER: 'Emetteur',
    CHART_TRAIN_DATE: 'Date train',
    CHART_DEPARTURE: 'Départ',
    CHART_ARRIVAL: 'Arrivée',
    CHART_STATIONS: 'Gare',
    CHART_TIME: 'Heure',
    CHART_SEND_STATUS: "Statut d'envoi",
    CHART_EMAIL: 'Email',
    CHART_WHATSAPP: 'WhatsApp',
    CHART_LAST_SEND_DETAILS: 'Détail',
    CHART_CUSTOMERS: 'Clients',
    CHART_SELECTED_STATION: 'Gare sélectionnée',
    CHART_TARGETING: 'Ciblages',
    CHART_EXCLUSION: 'Exclusion de montée',
    CHART_CARRIAGE: 'Voiture',
    CHART_OTHER: 'Autres',
    CHART_CHANNEL: "Canaux d'envoi",
    CHART_DELAY: 'Volume de retard',
    CHART_UP: '-haut',
    CHART_DOWN: '-bas',
    CHART_YES: 'Oui',
    CHART_NO: 'No',
    CHART_COMPENSATION: 'Compensation',
    CHART_AMOUNT_COMPENSATION: 'Montant de compensation',
    CHART_YES_COMPENSATION: 'oui',
    CHART_NO_COMPENSATION: 'non',
    CHART_PROGRAMMATION_ELEMENTS: 'Eléments de programmation',
    CHART_DAYS_BEFORE_CIRCULATION: 'Nombre de jours avant circulation',
    CHART_SENT_TIME: `Heure d'envoi`,
  },
  Modal: {
    USER_MODAL_TITLE: 'Confirmer avant suppression',
    USER_DELETE_CONFIRM: "Voulez-vous supprimer l'utilisateur ",
    PROFIL_DELETE_CONFIRM: 'Voulez-vous supprimer le profil suivant ',
    CONFIRM_YES: 'Oui',
    CONFIRM_NO: 'Non',
    HELPINFO_MODAL_TITLE: 'Confirmer avant suppression',
    HELPINFO_DELETE_CONFIRM: 'Voulez-vous supprimer la phrase-type suivante ',
    REASON_MODAL_TITLE: 'Confirmer avant suppression',
    REASON_DELETE_CONFIRM: 'Voulez-vous supprimer le motif suivant: ',
    SITUATION_DELETE_CONFIRM: 'Voulez-vous supprimer la situation suivante ? ',
    PRODUCT_CODE_DELETE_CONFIRM: 'Voulez-vous supprimer le code produit suivant: ',
    PRODUCT_CODE_MODAL_TITLE: 'Confirmer avant suppression',
    TYPOLOGY_DELETE_CONFIRM: 'Voulez-vous supprimer la typologie suivante :',
    HISTORIC_PENDING_MESSAGE_CONFIRM:
      "Attention, confirmez-vous l'annulation de l'envoi programmé pour ces trains/dates :",
    ERROR: "Attention, aucune compensation ne sera créée. Voulez-vous poursuivre l'envoi ou le modifier ?",
    BTN1: 'Ne pas envoyer et modifier.',
    BTN2: "Confirmer l'envoi.",
    WARNING_SITUATION: 'Attention, cela entraînera la suppression de tous les paramétrages associés à cette situation.',
    DELETE_MODAL: {
      OK: 'ok',
      message: "L'action a échoué. Merci de réessayer.",
    },
    CONTINUE: 'Continuer',
    TRAIN_WARNING: 'Attention, vous êtes sur le point d’envoyer une communication sur le train %{serviceName} du ',
    TRAIN_WARNING_DATE: '%{serviceDay} %{serviceDate}.',
  },
  notif: {
    NOTIF_SENDING_OK_TITTLE: "Confirmation d'envoi",
    NOTIF_SENDING_OK_TEXT: 'La communication a été envoyée avec succès',
    NOTIF_SENDING_KO_TITTLE: "Echec d'envoi",
    NOTIF_SENDING_KO_TEXT: "L'envoi de la communication a échoué.",
    NOTIF_DECONNEXION: 'Vous avez été déconnecté suite à la modification de votre compte.',
  },
  popin: {
    SELECTED_COACHES: 'Voitures sélectionnées',
    POPIN_DETAILS_CREATION_DATE_TIME: 'Date et heure de la création',
    POPIN_DETAILS_SEND_DATE_TIME: "Date et heure d'envoi",
    POPIN_DETAILS_SCHEDULED_DATE_TIME: "Date et heure d'envoi programmé",
    POPIN_DETAILS_PLATFORM: 'Quai',
    POPIN_DETAILS_REASON: 'Motif',
    POPIN_DETAILS_INCIDENT: "Détails sur l'incident",
    POPIN_DETAILS_COMPENSATION: 'Compensation',
    POPIN_DETAILS_SAV: 'Mesures de dédommagement',
    POPIN_DETAILS_SUBSTITUTION_STATION: 'Gare de substitution',
    POPIN_DETAILS_NEW_SCHEDULE: 'Nouvel horaire',
    POPIN_DETAILS_ASCENDING_STATIONS_EXCLUSION: 'Exclusion gares de montée',
    POPIN_DETAILS_ODS_SUMMARY_LABEL: 'Récapitulatif des OD :',
    POPIN_SITUATION: 'Situation',
    POPIN_DETAILS_DELAY: 'Retard',
    POPIN_CLOSED_BAR: 'Bar fermé',
    POPIN_DETAILS_INFORMATION_COM: 'Information à communiquer (long)',
    POPIN_DETAILS_INFORMATION_COM_SHORT: 'Information à communiquer (court)',
    POPIN_DETAILS_OTHER_INFORMATION_COM: 'Information complémentaire (long)',
    POPIN_DETAILS_OTHER_INFORMATION_COM_SHORT: 'Information complémentaire (court)',
    POPIN_SERVICE_NUMBER: 'Train n°',
    POPIN_DETAILS_SIGNATURE: 'Signature',
    POPIN_TRANSMITTER: 'Emetteur',
    POPIN_CHANNEL: "Canaux d'envoi",
    POPIN_MAIL_OBJECT: 'Objet du mail',
    POPIN_HEADER_TITLE: 'Titre du bandeau',
    POPIN_CLIENTS_TYPE: 'Type de clients',
    POPIN_DV_NUMBERS: 'DV ciblés',
    POPIN_IMPACTED_STATIONS: 'Gare concernée',
    POPIN_EXCLUDED_STATIONS: 'Exclusion gare(s) de montée',
    POPIN_OTHERS: 'Autres',
    POPIN_UPSTAGE: '-haut',
    POPIN_DOWNSTAGE: '-bas',
    POPIN_PASSENGERS_WITHOUT_SEATS: ' / Sans placement: ',
    CONCERNED_PASSENGERS: 'Nombre de passagers ciblés :',
  },
  confirmation: {
    TEXT_CONF_PAGE_OK_1: 'La communication a été envoyée avec succès.',
    TEXT_CONF_PAGE_OK_2: "Merci de fermer l'onglet avant d'envoyer une autre communication.",
    TEXT_CONF_PAGE_KO_1: "L'envoi a échoué. Merci de réessayer.",
    TEXT_CONF_PAGE_KO_STEP_1: 'Champs obligatoires en étape 1',
    TEXT_CONF_PAGE_KO_DEFFERED: "L'envoi est impossible. Veuillez modifier les paramètres d'envoi en différé demandés.",
    CLOSE_BUTTON: "Fermer l'onglet",
  },
  roles: {
    IVAdmin: 'Administrateur',
    IVAgent: 'Superviseur IV',
  },
  keywords: {
    tooltip: "tapez '{' pour ajouter des variables",
  },
  weekdaysInput: {
    mon: 'LU',
    tue: 'MA',
    wed: 'ME',
    thu: 'JE',
    fri: 'VE',
    sat: 'SA',
    sun: 'DI',
  },
  defaultError: 'Une erreur est survenue. Merci de réessayer.',
};

export default locale;
